import React from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',

    '&.checked': {
      '& .check-box': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
      },

      '& .check': {
        left: '-5px',
        top: '-5px',
        display: 'inline-block',
        color: 'var(--color-colorPrimary-main)',
      },
    },

    '&.indeterminate': {
      '& .check-box': {
        '& .check': {
          display: 'none',
        },

        '& .indeterminate': {
          left: '-5px',
          top: '-5px',
          display: 'inline-block',
          color: 'var(--color-colorPrimary-main)',
        },
      },
    },

    '& .check-box': {
      width: 18,
      height: 18,
      border: '2px solid',
      borderColor: 'var(--color-checkbox-border)',
      borderRadius: 2,
      marginRight: 12,
    },

    '& .check': {
      position: 'relative',
      display: 'none',
    },

    '& .indeterminate': {
      position: 'relative',
      display: 'none',
    },

    '& .message': {
      fontSize: '1rem',
      fontFamily: '"IBM Plex Sans", sans-serif',
      fontWeight: 400,
      lineHeight: '1.5',
    },
  },
}));

const CheckboxWithLabel = ({
  checked = false,
  indeterminate = false,
  onChange = () => {},
  className = '',
  children = '',
}) => {
  const classes = useStyles();

  return (
    <button
      className={`${classes.root} ${checked ? 'checked' : ''} ${
        checked && indeterminate ? 'indeterminate' : ''
      } ${className}`}
      onClick={onChange}
    >
      <div className="check-box">
        <CheckBoxIcon className="check" />
        <IndeterminateCheckBoxIcon className="indeterminate" />
      </div>

      <div className="message">{children}</div>
    </button>
  );
};

export default CheckboxWithLabel;
